export default async function prepareQualificationUpload(file) {
  if (!file) return file;
  const isHeic = /\.hei[cf]$/i.test(file.name || '') || /^image\/hei[cf](?:-sequence)?$/i.test(file.type || '');
  if (!isHeic) return file;

  const { heicTo } = await import('heic-to/csp');
  const jpeg = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.9 });
  if (!jpeg || jpeg.type !== 'image/jpeg' || !jpeg.size) {
    throw new Error('Image conversion did not produce a JPEG');
  }
  // eslint-disable-next-line no-undef
  return new File([jpeg], `${file.name.replace(/\.[^.]+$/, '')}.jpeg`, {
    type: 'image/jpeg',
    lastModified: file.lastModified
  });
}
